import React from "react";
import { ShieldCheck, Asterisk } from "lucide-react";
import { marqueeFeatures, networks } from "../mock";

export const ImportantNotice = () => (
  <section className="bg-[#f4f2fb] py-16">
    <div className="max-w-5xl mx-auto px-5 lg:px-8">
      <div className="reveal rounded-3xl border-2 border-[#7c3aed]/30 bg-white/60 p-8 lg:p-12">
        <div className="flex items-center gap-2 text-[#7c3aed] font-semibold text-xs tracking-[0.2em] uppercase mb-5">
          <ShieldCheck className="w-4 h-4" /> Important Notice
        </div>
        <h2 className="font-display text-2xl lg:text-3xl font-semibold text-[#1e183a] leading-snug">
          Important: We Are an Independent Third-Party Support Service
        </h2>
        <p className="mt-5 text-[#1e183a]/70 leading-relaxed">
          T4TECH is not affiliated with, endorsed by, or connected to any mobile
          network, broadband provider, or device manufacturer (including O2, EE,
          Vodafone, Three, Sky, BT or others). We are a fully independent service
          offering free general support and guidance.
        </p>
      </div>
    </div>
  </section>
);

export const FeatureMarquee = () => {
  const items = [...marqueeFeatures, ...marqueeFeatures, ...marqueeFeatures];
  return (
    <div className="marquee-wrap bg-[#1e183a] py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {items.map((f, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display font-semibold text-white text-3xl lg:text-4xl px-8">
              {f}
            </span>
            <Asterisk className="w-6 h-6 text-[#7c3aed]" strokeWidth={2.5} />
          </span>
        ))}
      </div>
    </div>
  );
};

export const NetworkMarquee = () => {
  const items = [...networks, ...networks, ...networks];
  return (
    <section className="bg-[#ece9f8] py-14 overflow-hidden">
      <p className="text-center text-xs font-semibold tracking-[0.22em] uppercase text-[#1e183a]/50 mb-9 px-5">
        Independent advice for customers of all major UK networks
      </p>
      <div className="marquee-wrap overflow-hidden">
        <div className="flex w-max animate-marquee-slow items-center">
          {items.map((n, i) => (
            <span
              key={i}
              className="font-display font-semibold text-2xl lg:text-3xl text-[#1e183a]/70 px-10 whitespace-nowrap"
            >
              {n}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
